const IP_URL = process.env.REACT_APP_NODE_API_URL

export const tumBetweenDatetimes = async (equipment_name, initial_datetime, end_datetime, route_bd) => {
    try {
        var urlTum = IP_URL + route_bd + "-tum/tumBetweenDatetimes";
        console.log('listado ', urlTum)
        console.log('Logs Track Replay Tum ', urlTum);
        console.log('Logs Track Replay Tum ', equipment_name)
        console.log('Logs Track Replay Tum ', initial_datetime)
        console.log('Logs Track Replay Tum ', end_datetime)
        const response = await fetch(urlTum, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ equipment_name, initial_datetime, end_datetime}),
      });
      const data = await response.json();
      console.log('Logs Track Replay Tum ', data);
      return data;
    } catch (error) {
      var aux_err = 0;
      //console.error("Error al iniciar sesión", error);
    }
  }; 


export const actualTumSimberi = async () => {
    try {
        const response = await fetch(IP_URL + "tum/actualTum", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({equipment_name: 1}),
      });
      const data = await response.json();
      return data;
    } catch (error) {
      var aux_err = 0;
      //console.error("Error al iniciar sesión", error);
    }
  }; 